import styled from "styled-components";
import { Link } from "react-scroll";

interface Props {
  mobile?: boolean;
  onNavigate?: () => void;
}

const Container = styled.nav<{ $mobile?: boolean }>`
  display: flex;
  gap: ${({ $mobile }) => ($mobile ? "8px" : "30px")};
  align-items: ${({ $mobile }) => ($mobile ? "stretch" : "center")};
  flex-direction: ${({ $mobile }) => ($mobile ? "column" : "row")};
`;

const NavLink = styled(Link)<{ $mobile?: boolean }>`
  color: #343a40;
  text-decoration: none;
  font-size: ${({ $mobile }) => ($mobile ? "18px" : "15px")};
  font-weight: 500;
  transition: all 0.3s ease;
  cursor: pointer;
  padding: ${({ $mobile }) => ($mobile ? "12px 16px" : "8px 16px")};
  border-radius: 10px;

  &.active {
    color: #007bff;
    background-color: rgba(0, 123, 255, 0.06);
  }

  &:hover {
    color: #007bff;
    background-color: rgba(0, 123, 255, 0.06);
  }
`;

const Navigation = ({ mobile, onNavigate }: Props) => {
  return (
    <Container $mobile={mobile}>
      <NavLink
        to="about"
        smooth={true}
        duration={500}
        $mobile={mobile}
        onClick={onNavigate}
      >
        About
      </NavLink>
      <NavLink
        to="lone"
        smooth={true}
        duration={500}
        $mobile={mobile}
        onClick={onNavigate}
      >
        Service
      </NavLink>
      <NavLink
        to="contact"
        smooth={true}
        duration={500}
        $mobile={mobile}
        onClick={onNavigate}
      >
        Contact
      </NavLink>
    </Container>
  );
};

export default Navigation;
